import { withNamespaces } from 'react-i18next';
import { Button } from 'reactstrap';

const DangerZone = ({
    t,
    isFetching,
    isFirstTime,
    active,
    isSaving,
    onToggleActivation,
}) => {
    if (isFirstTime) {
        return null;
    }

    return (
        <div className="mailer-settings__deactivate">
            <div>
                <div className="mailer-settings__deactivate-title">
                    {active
                        ? t('Deactivate email settings')
                        : t('Activate email settings')}
                </div>
                <div className="mailer-settings__deactivate-description">
                    {active
                        ? t('Stops the system from sending emails. You can reactivate any time.')
                        : t('Lets the system send all emails with this configuration.')}
                </div>
            </div>
            <Button
                type="button"
                color={active ? 'danger' : 'success'}
                outline={active}
                disabled={isFetching || isSaving}
                onClick={onToggleActivation}
            >
                {active ? t('Deactivate') : t('Activate')}
            </Button>
        </div>
    );
};

export default withNamespaces()(DangerZone);
